import { render } from "./SectionHP.vue?vue&type=template&id=3f0bf2ac&scoped=true"
import script from "./SectionHP.vue?vue&type=script&lang=js"
export * from "./SectionHP.vue?vue&type=script&lang=js"

import "./SectionHP.vue?vue&type=style&index=0&id=3f0bf2ac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0bf2ac"]])

export default __exports__